import React  from "react";
import {
    Modal,
    Button, 
} from "react-bootstrap";

export default function GenericModal (props) {
    let title;
    let body;
    // console.log(props)
    let show = props.show;
    const handleClose = () => props.setShow(false);
    if (props.success){
        title = "Email sent.";
        body = 'Check your inbox and click the button in the email to verify your account. You have 4 hours to verify your account.';
    } else {
        title = "Woops!";
        body = 'Something went wrong';
    }
   
    return (
      <>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
            <Modal.Body>{body}</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
